import { FormFieldWidget, ModelFieldType, SPI, ViewType, Widget } from '@kunlun/dependencies';
import ProductProperty from './ProductProperty.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Detail,
    ttype: ModelFieldType.String,
    widget: 'ProductProperty',
    multi: false
  })
)
export class DetailStringProductPropertyFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(ProductProperty);
    return this;
  }

  @Widget.Reactive()
  private data: any = {};

  @Widget.Watch('formData.attributeCommit', { deep: true })
  private watchAttrs(val: any) {
    if (val) {
      this.data = JSON.parse(val);
    }
  }
}
